var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24.7535,
    cy: 25.2608,
    r: 24.2535,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.62 25.2973C21.06 28.1273 23.38 30.4373 26.21 31.8873L28.41 29.6873C28.68 29.4173 29.08 29.3273 29.43 29.4473C30.55 29.8173 31.76 30.0173 33 30.0173C33.55 30.0173 34 30.4673 34 31.0173V34.5073C34 35.0573 33.55 35.5073 33 35.5073C23.61 35.5073 16 27.8973 16 18.5073C16 17.9573 16.45 17.5073 17 17.5073H20.5C21.05 17.5073 21.5 17.9573 21.5 18.5073C21.5 19.7573 21.7 20.9573 22.07 22.0773C22.18 22.4273 22.1 22.8173 21.82 23.0973L19.62 25.2973Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneIcon);
export default __webpack_public_path__ + "static/media/contactPhoneIcon.2c7755b5b00666e154c5d50a74bd474b.svg";
export { ForwardRef as ReactComponent };